if (!customElements.get('cph-product-purchase')) {
  customElements.define(
    'cph-product-purchase',
    class extends HTMLElement {
      connectedCallback() {
        this.desktop = window.matchMedia('(min-width: 1100px)');
        this.scheduleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateCompactState();
          });
        };
        window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleUpdate);
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.parentElement);
        this.scheduleUpdate();
      }

      updateCompactState() {
        // The column stays in normal flow, so shrinking the sticky panel cannot
        // move this threshold or cause the compact state to oscillate.
        const stickyTop = parseFloat(getComputedStyle(this).top) || 0;
        const compact =
          this.desktop.matches &&
          this.classList.contains('cph-product-purchase--sticky') &&
          this.parentElement.getBoundingClientRect().top < stickyTop - 1 &&
          !this.querySelector('.recipient-form');
        this.classList.toggle('is-compact', compact);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scheduleUpdate);
        window.removeEventListener('resize', this.scheduleUpdate);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }
  );
}
